import React from "react";
import { getLanguageSection } from "../../../shared/services/languageService";

function ReservHotelContactModal({ isOpen, onClose, title }) {
  const language = getLanguageSection("contactmodal");

  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-[1200] flex items-center justify-center bg-[#151b3f]/60 px-4 py-6 backdrop-blur-sm">
      <div className="w-full max-w-[520px] rounded-2xl border border-slate-200 bg-white p-6 shadow-[0_24px_70px_rgba(17,24,63,0.24)] md:p-8">
        <div className="mb-5 flex items-start justify-between gap-4">
          <div>
            <p className="m-0 mb-2 text-xs font-black uppercase tracking-[0.18em] text-[#ef5d70]">
              {title || language.eyebrow}
            </p>
            <h2 className="m-0 text-2xl font-black text-[#151b3f]">
              {language.heading}
            </h2>
          </div>
          <button
            type="button"
            className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-slate-200 bg-white text-[#151b3f] hover:border-[#4aa6cf] hover:text-[#4aa6cf]"
            aria-label={language.closeLabel}
            onClick={onClose}
          >
            <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M6 6l12 12M18 6 6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </button>
        </div>

        <p className="m-0 mb-6 text-sm leading-6 text-slate-600">
          {language.intro}
        </p>

        <div className="grid gap-4">
          <div className="rounded-xl border border-slate-200 bg-slate-50 p-4">
            <h3 className="m-0 text-base font-black text-[#151b3f]">Mirian Villanueva</h3>
            <p className="m-0 mt-1 text-sm text-slate-500">{language.roles.redemptionCoordinator}</p>
            <a className="mt-3 block break-words text-sm font-black text-[#4aa6cf] hover:text-[#202865]" href="mailto:asistente.ventas.mg@marivalresorts.com">
              asistente.ventas.mg@marivalresorts.com
            </a>
          </div>

          <div className="rounded-xl border border-slate-200 bg-slate-50 p-4">
            <h3 className="m-0 text-base font-black text-[#151b3f]">Marc Murphy</h3>
            <p className="m-0 mt-1 text-sm text-slate-500">{language.roles.businessDevelopment}</p>
            <a className="mt-3 block break-words text-sm font-black text-[#4aa6cf] hover:text-[#202865]" href="mailto:mmurphy@marivalresorts.com">
              mmurphy@marivalresorts.com
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReservHotelContactModal;
